export const tw = (className: TemplateStringsArray, ...classNames: string[]) =>
  String.raw({ raw: className }, ...classNames);
